import React from 'react';
import { useAuth } from '../context/AuthContext'; 
import { auth } from '../servicios/firebase';
import { Link } from 'react-router-dom'; 

const Dashboard = () => {
  const { user } = useAuth();
  
  const esSuper = user?.rol === 'super_admin';
  const esSucursal = user?.rol === 'admin_sucursal';
  const esChofer = user?.rol === 'chofer'; // 👈 NUEVO

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-6xl mx-auto">
        
        {/* ENCABEZADO - visible para todos */}
        <div className="bg-white rounded-xl shadow-md p-6 mb-8 flex flex-col md:flex-row justify-between items-center gap-4 border-l-4 border-blue-600">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">Hola, {user?.nombre || 'Admin'} 👋</h1>
            <p className="text-gray-500">
              Rol: <span className="font-bold text-blue-600 uppercase">{user?.rol?.replace('_', ' ')}</span> • 
              Sucursal: <span className="font-bold text-gray-700 uppercase">{user?.sucursal || 'Global'}</span>
            </p>
          </div>
          <button 
            onClick={() => auth.signOut()}
            className="bg-red-50 text-red-600 px-5 py-2 rounded-lg border border-red-100 hover:bg-red-100 transition font-medium text-sm"
          >
            Cerrar Sesión
          </button>
        </div>

        {/* 🚌 VISTA CHOFER - solo escáner */}
        {esChofer && (
          <div>
            <h2 className="text-lg font-bold text-gray-700 mb-4">🚌 Panel Chofer</h2>
            <Link to="/admin/validar-boleto" className="group block">
              <div className="bg-gradient-to-r from-green-500 to-green-600 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all relative overflow-hidden">
                <div className="absolute -bottom-4 -right-4 opacity-10 text-9xl">📱</div>
                <div className="relative z-10">
                  <div className="h-16 w-16 bg-white/20 rounded-xl flex items-center justify-center text-4xl mb-4 group-hover:scale-110 transition-transform">
                    📱
                  </div>
                  <h3 className="font-black text-white text-2xl mb-2">Validar Boletos</h3>
                  <p className="text-green-100 text-sm font-medium">
                    Escanea el QR del pasajero para validar su boleto.
                  </p>
                  <div className="mt-4 inline-block bg-white/20 text-white text-xs font-bold px-3 py-1.5 rounded-full">
                    → Abrir Escáner
                  </div>
                </div>
              </div>
            </Link>
          </div>
        )}

        {/* TODO LO DEMÁS - oculto para choferes */}
        {!esChofer && (
          <>
            {/* ── 1. OPERACIÓN PRINCIPAL ─────────────────────────────────── */}
            <h2 className="text-lg font-bold text-gray-700 mb-4 flex items-center gap-2">
              🎟️ Operación Principal
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <Link to="/admin/salidas" className="group">
                <div className="bg-gradient-to-r from-emerald-500 to-emerald-600 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all cursor-pointer h-full relative overflow-hidden">
                  <div className="absolute -bottom-4 -right-4 opacity-10 text-9xl">🎟️</div>
                  <div className="relative z-10">
                    <div className="h-16 w-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center text-4xl mb-4 group-hover:scale-110 transition-transform">
                      🎟️
                    </div>
                    <h3 className="font-black text-white text-2xl mb-2">Taquilla / Venta de Boletos</h3>
                    <p className="text-emerald-100 text-sm font-medium">
                      Vender boletos, consultar salidas de hoy, mapa de asientos en tiempo real.
                    </p>
                    <div className="mt-4 inline-block bg-white/20 backdrop-blur-sm text-white text-xs font-bold px-3 py-1.5 rounded-full">
                      → Ir a Taquilla
                    </div>
                  </div>
                </div>
              </Link>

              <Link to="/admin/liquidaciones" className="group">
                <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all cursor-pointer h-full relative overflow-hidden">
                  <div className="absolute -bottom-4 -right-4 opacity-10 text-9xl">🧾</div>
                  <div className="relative z-10">
                    <div className="h-16 w-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center text-4xl mb-4 group-hover:scale-110 transition-transform">
                      🧾
                    </div>
                    <h3 className="font-black text-white text-2xl mb-2">Liquidaciones</h3>
                    <p className="text-amber-100 text-sm font-medium">
                      Cuentas y pagos por dueño.
                    </p>
                    <div className="mt-4 inline-block bg-white/20 backdrop-blur-sm text-white text-xs font-bold px-3 py-1.5 rounded-full">
                      → Ver Liquidaciones
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            {/* ── 2. REPORTES (grande, ancho completo) ───────────────────── */}
            <h2 className="text-lg font-bold text-gray-700 mb-4 flex items-center gap-2">
              📊 Análisis y Reportes
            </h2>

            <Link to="/admin/reportes" className="group block mb-8">
              <div className="bg-gradient-to-r from-indigo-500 to-violet-600 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all cursor-pointer relative overflow-hidden">
                <div className="absolute -bottom-4 -right-4 opacity-10 text-9xl">📊</div>
                <div className="relative z-10 flex flex-col md:flex-row md:items-center gap-6">
                  <div className="h-16 w-16 shrink-0 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center text-4xl group-hover:scale-110 transition-transform">
                    📊
                  </div>
                  <div>
                    <h3 className="font-black text-white text-2xl mb-1">Reportes</h3>
                    <p className="text-indigo-100 text-sm font-medium">
                      Ventas, ingresos y gráficas de tu sucursal. Consulta el desempeño en tiempo real.
                    </p>
                    <div className="mt-3 inline-block bg-white/20 backdrop-blur-sm text-white text-xs font-bold px-3 py-1.5 rounded-full">
                      → Ver Reportes
                    </div>
                  </div>
                </div>
              </div>
            </Link>

            {/* ── 3. CONFIGURACIÓN - solo super admin ─────────────────────── */}
            {esSuper && (
              <>
                <h2 className="text-lg font-bold text-gray-700 mb-4 flex items-center gap-2">
                  ⚙️ Configuración del Sistema <span className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full font-bold">SUPER ADMIN</span>
                </h2>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-10">
                  <Link to="/admin/precios" className="group">
                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all cursor-pointer group-hover:border-blue-400 h-full relative overflow-hidden">
                      <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity text-6xl">💰</div>
                      <div className="h-12 w-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform">💰</div>
                      <h3 className="font-bold text-gray-800 group-hover:text-blue-600">Precios</h3>
                      <p className="text-xs text-gray-500 mt-2">Tarifas base y promociones.</p>
                    </div>
                  </Link>

                  <Link to="/admin/terminales" className="group">
                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all cursor-pointer group-hover:border-orange-400 h-full relative overflow-hidden">
                      <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity text-6xl">📍</div>
                      <div className="h-12 w-12 bg-orange-100 text-orange-600 rounded-lg flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform">📍</div>
                      <h3 className="font-bold text-gray-800 group-hover:text-orange-600">Terminales</h3>
                      <p className="text-xs text-gray-500 mt-2">Sucursales y Zonas.</p>
                    </div>
                  </Link>

                  <Link to="/admin/horarios" className="group">
                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all cursor-pointer group-hover:border-purple-400 h-full relative overflow-hidden">
                      <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity text-6xl">🚐</div>
                      <div className="h-12 w-12 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform">🚐</div>
                      <h3 className="font-bold text-gray-800 group-hover:text-purple-600">Rutas</h3>
                      <p className="text-xs text-gray-500 mt-2">Logística, horarios y días.</p>
                    </div>
                  </Link>

                  <Link to="/admin/usuarios" className="group">
                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all cursor-pointer group-hover:border-cyan-400 h-full relative overflow-hidden">
                      <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity text-6xl">👥</div>
                      <div className="h-12 w-12 bg-cyan-100 text-cyan-600 rounded-lg flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform">👥</div>
                      <h3 className="font-bold text-gray-800 group-hover:text-cyan-600">Equipo</h3>
                      <p className="text-xs text-gray-500 mt-2">Crear Admins y Accesos.</p>
                    </div>
                  </Link>

                  <Link to="/admin/flota" className="group">
                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all cursor-pointer group-hover:border-green-500 h-full relative overflow-hidden">
                      <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity text-6xl">🚌</div>
                      <div className="h-12 w-12 bg-green-100 text-green-600 rounded-lg flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform">🚌</div>
                      <h3 className="font-bold text-gray-800 group-hover:text-green-600">Flota</h3>
                      <p className="text-xs text-gray-500 mt-2">Dueños, urbanas y choferes.</p>
                    </div>
                  </Link>

                  <Link to="/admin/validar-boleto" className="group">
                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all cursor-pointer group-hover:border-green-400 h-full relative overflow-hidden">
                      <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity text-6xl">📱</div>
                      <div className="h-12 w-12 bg-green-100 text-green-600 rounded-lg flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform">📱</div>
                      <h3 className="font-bold text-gray-800 group-hover:text-green-600">Validar Boletos</h3>
                      <p className="text-xs text-gray-500 mt-2">Escanear QR desde el celular.</p>
                    </div>
                  </Link>
                </div>
              </>
            )}

            {esSucursal && (
              <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-lg">
                <p className="text-sm text-blue-800">
                  <span className="font-bold">💡 Nota:</span> Como administrador de sucursal, tienes acceso a las operaciones principales. Para cambios en precios, rutas o configuraciones globales, contacta al Super Admin.
                </p>
              </div>
            )}
          </>
        )}

      </div>
    </div>
  );
};

export default Dashboard;